import {iterItems, mapItems, dict, flatten} from 'ldash'

import {createAction} from 'redux-actions'

// save overlay plaintext version
export let saveDomainConfig = createAction('SAVE_DOMAIN_CONFIG', (dname, text, validate) => ({
  dname,
  text,
  validate,
}))
// save modified values into overlay
export let saveDomainConfigValues = createAction('SAVE_DOMAIN_CONFIG_VALUES', (dname, values) => ({
  dname,
  values,
}))
// reload server side config system (for dname + decendant dnames)
export let rebuildDomainConfig = createAction('REBUILD_DOMAIN_CONFIG', dname => ({dname}))
// signal readiness
export let rebuildDomainConfigDone = createAction('REBUILD_DOMAIN_CONFIG_DONE', dnames => ({
  dnames,
}))

export let loadDomainConfigSpec = createAction('LOAD_DOMAIN_CONFIG_SPEC')
export let loadDomainConfigSections = createAction(
  'LOAD_DOMAIN_CONFIG_SECS',
  (dname, sections) => ({
    dname,
    sections,
  })
)

export let setDomainConfigSections = createAction('SET_DOMAIN_CONFIG_SECS', (dname, sections) => ({
  dname,
  sections,
}))
export let setSpecLoading = createAction('SET_SPEC_LOADING')
export let setDomainConfigSpec = createAction('SET_DOMAIN_CONFIG_SPEC', spec => ({spec}))

// load from server
export let loadConfigOverlay = createAction('LOAD_CONFIG_OVERLAY', dname => ({dname}))
// write to store
export let setConfigOverlay = createAction('SET_CONFIG_OVERLAY', (dname, data) => ({dname, data}))

export const setAppConfig = createAction('SET_APP_CONFIG', ({config, router}) => {
  let {domains} = config
  domains = {...domains}

  // setup calculated stuff for domains structure
  domains.prefix2name = {}
  domains.name2prefix = {}
  domains.odid2name = {}
  domains.otid2name = {}

  domains.names = [] // contains names in tree order
  domains.ghostNames = []

  let rootDomain = null
  // domains.data is in tree order
  iterItems(domains.data, (dname, ddata) => {
    domains.prefix2name[ddata.routingPrefix] = dname
    domains.name2prefix[dname] = ddata.routingPrefix
    domains.odid2name[ddata.id] = dname
    domains.otid2name[ddata.otid] = dname
    // XXX: ambigious rootDomain eval
    if (ddata.root) {
      rootDomain = dname
    } else if (rootDomain === null && ddata.parent === null && !ddata.isGhost) {
      rootDomain = dname
    }
    if (ddata.isGhost) {
      domains.ghostNames.push(dname)
    } else {
      domains.names.push(dname)
    }
  })
  domains.rootDomain = rootDomain

  let {typesById, ...irest} = config.instance

  let dt_transport = -1 // see uix.py/typesById()
  let not_dt_transport = st => parseInt(st) != dt_transport
  let datatypeMap = dict(mapItems(typesById, (dt, subtypes) => [dt, subtypes[dt_transport]]))
  // call it itypes, since dtypes is already notated mostly as types
  // align with src/reducers/initialConfigState
  let itypes = {
    byId: typesById,
    byName: dict(
      flatten(
        mapItems(typesById, (dt, subtypes) =>
          mapItems(subtypes, (st, name) => [name, [parseInt(dt), parseInt(st)]], not_dt_transport)
        )
      )
    ),
    datatypeMap,
    datatypeMapInverse: dict(mapItems(datatypeMap, (k, v) => [v, k])),
  }

  // store config creation time
  // can be used as a identifier for application initialization run
  config = {...config, domains, instance: {...irest, itypes}, time: new Date().getTime()}

  return {config, router}
})
